// Serve the regional .pmtiles archive from memory.
// Cloudflare Pages answers Range requests with the whole file (HTTP 200), which the stock
// FetchSource rejects. Our archive is small (~1.4 MB), so we download it once and slice ranges
// locally. One request also makes offline caching (Phase 5) a single file.
import { PMTiles, Protocol } from 'pmtiles';

export class WholeFileSource {
  constructor(url) {
    this.url = url;
    this.buffer = null;
  }

  getKey() {
    return this.url;
  }

  async getBytes(offset, length) {
    this.buffer ??= fetch(this.url).then((r) => {
      if (!r.ok) throw new Error(`${this.url}: HTTP ${r.status}`);
      return r.arrayBuffer();
    });
    const buf = await this.buffer;
    return { data: buf.slice(offset, offset + length) };
  }
}

/** Register the pmtiles:// protocol with MapLibre, backed by an in-memory copy of `url`. */
export function registerTiles(addProtocol, url) {
  const protocol = new Protocol();
  protocol.add(new PMTiles(new WholeFileSource(url)));
  addProtocol('pmtiles', protocol.tile);
}
